/**
 * Recursively strips leading and trailing whitespace, periods, and linebreaks from notes.
 * Preserves internal formatting. Returns empty string if input is empty/undefined/null.
 *
 * @example
 * formatBiomarkerNotes(" . Test note . ") → "Test note"
 * formatBiomarkerNotes("\n\nNote with spaces\n\n") → "Note with spaces"
 */
export const formatBiomarkerNotes = (notes: string | null | undefined): string => {
  if (!notes) return '';

  let cleaned = notes;
  let previous = '';

  // Recursively strip until no more characters can be removed
  while (cleaned !== previous) {
    previous = cleaned;
    // Strip whitespace (spaces, tabs, newlines, carriage returns) and periods from both ends
    cleaned = cleaned.replace(/^[\s.\n\r]+|[\s.\n\r]+$/g, '');
  }

  return cleaned;
};
